export default __webpack_public_path__ + "static/media/Partner1.2bf3d885.svg";